import { defineComponent as n, createElementBlock as s, openBlock as t, mergeProps as m, unref as r, createElementVNode as d, normalizeClass as p } from "vue";
import l from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Spinner/spinner.js";
import { c_spinner_diameter as u } from "../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_spinner_diameter.js";
import { useOUIAProps as f } from "../helpers/ouia.js";
const b = ["aria-valuetext", "aria-label", "aria-labelledby"];
var c = /* @__PURE__ */ ((a) => (a.sm = "sm", a.md = "md", a.lg = "lg", a.xl = "xl", a))(c || {});
const P = /* @__PURE__ */ n({
  name: "PfSpinner",
  __name: "Spinner",
  props: {
    size: { default: "xl" },
    ariaValueText: { default: "Loading..." },
    diameter: {},
    inline: { type: Boolean },
    ariaLabel: {},
    ariaLabelledby: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(a) {
    const i = a, o = f({ id: i.ouiaId, safe: i.ouiaSafe });
    return (e, y) => (t(), s("svg", m(r(o), {
      class: [
        r(l).spinner,
        e.inline ? [r(l).modifiers.inline] : r(l).modifiers[e.size]
      ],
      role: "progressbar",
      viewBox: "0 0 100 100",
      style: e.diameter ? {
        [r(u).name]: e.diameter
      } : void 0,
      "aria-valuetext": e.ariaValueText,
      "aria-label": !e.ariaLabel && !e.ariaLabelledby ? "Contents" : e.ariaLabel,
      "aria-labelledby": e.ariaLabelledby
    }), [
      d("circle", {
        class: p(r(l).spinnerPath),
        cx: "50",
        cy: "50",
        r: "45",
        fill: "none"
      }, null, 2)
    ], 16, b));
  }
});
export {
  P as default,
  c as spinnerSize
};
